import { AdvisorsTable } from '@/modules/employerAdvisors/pages/components/AdvisorsTable/AdvisorsTable'

export function EmployerAdvisorsShell() {
  return <AdvisorsTable />
}
